export default __webpack_public_path__ + "static/media/p36.4e19e922.jpg";